module.exports = __webpack_public_path__ + "img/27002568000289.149fa59c.png";